import React from "react"

import { Drawer, Box, Toolbar, Paper } from '@mui/material'
import { useTheme } from '@mui/material/styles';

//ads
import Ads from '../GoogleAdSense'

//メモ：普通にmaterial-uiのtheme側のブレークポイントを使うと
//非表示になったときにwidthが0で表示領域がないというadsのエラーが出る
//そのため広告が表示されない＋全部レンダリングされないので解決柵としてコード側で表示を切り替える

//非表示は上のコンポーネントで行う方法に変更

//ドロワ
const DrawerComponent = (({ location }) => {

    const drawerWidthRightAds = "470px"
    const theme = useTheme()
    // const isFirstEnter = theme.status?.isFirstEnter //この方式は廃止

    const path = location ? location.pathname : "error: no path"

    return (
        <Drawer
            anchor="right"
            sx={{
                //ドロワのカラーをオーバーライド
                //MuiPaperの調べ方はブラウザF12でタゲったときに表示されるやつをもってくる
                '& .MuiPaper-root': {
                    backgroundColor: theme.palette.background.default,
                },
                width: drawerWidthRightAds,
                flexShrink: 0,
                '& .MuiDrawer-paper': { width: drawerWidthRightAds, border: 0 },
                // ...(isFirstEnter && { //この方式は廃止
                //     visibility: "hidden",
                // }),
            }}
            variant="persistent"
            open={true}
        >
            <Toolbar />
            {/* <Container sx={{
                overflow: 'auto',
            }}> */}
                <Box pt={3} mb={1}>
                    <Paper variant={process.env.NODE_ENV === "development" ? "outlined" : "none"}

                        sx={{
                            width: "160px", height: "500px",
                            backgroundColor: "inherit",
                        }}
                    >
                        <Ads
                            path={path}
                            slot={process.env.GOOGLE_AD_SLOT3}
                            format={"auto"} />
                    </Paper>
                </Box>
            {/* </Container> */}
        </Drawer >
    )
}
);

export default DrawerComponent